import men from '../../Images/About/men (1).png'
import sandp from '../../Images/About/sandp.jpg'
import mnj from '../../Images/About/mnj.jpg'

import {FaTwitter, FaLinkedinIn} from 'react-icons/fa';


const Content =[
    {
        id:1,
        image: sandp,
        name:"Sandip K Shrivastava",
        post:"Director",
        socialmedia:[
            {
                path:"/",
                icon:<FaLinkedinIn/>,
            },
            {
                path:"/",
                icon:<FaTwitter/>,
            },
        ],
        
    },
    {
        id:2,
        image: mnj,
        name:"Manoj Shrivastava",
        post:"Director",
        socialmedia:[
            {
                path:"/",
                icon:<FaLinkedinIn/>,
            },
            {
                path:"/",
                icon:<FaTwitter/>,
            },
        ],
        
    },
    
   
  
];
export default Content;